module.exports = __webpack_public_path__ + "24e004ab/img/arrow-share-icon.00a12c29.svg";